import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { AfterOauthLoginComponent } from './after-oauth-login/after-oauth-login.component';
import { DeviceLoginDoneComponent } from './device-login-done/device-login-done.component';
import { PasswordRecoveryComponent } from './password-recovery/password-recovery.component';
import { DeletionComponent } from './deletion/deletion.component';
import { DeletionAfterOauthComponent } from './deletion-after-oauth/deletion-after-oauth.component';
import { UseInvitationComponent } from './use-invitation/use-invitation.component';

const routes: Routes = [
  { path: '', component: LoginComponent, pathMatch: 'full' },
  { path: 'after-oauth', component: AfterOauthLoginComponent },
  { path: 'device-login-done', component: DeviceLoginDoneComponent },
  { path: 'password-recovery', component: PasswordRecoveryComponent },
  { path: 'deletion', component: DeletionComponent },
  { path: 'deletion-after-oauth', component: DeletionAfterOauthComponent },
  { path: 'invitation/:id/:key', component: UseInvitationComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthenticationRoutingModule { }
